var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import AvatarPlaceholder from '../../../components/AvatarPlaceholder';
import { Wrapper, Drawer, Icon } from '@mademine/components';
import { I18n } from '@mademine/utils';
import { ReactComponent as SubscriptIcon } from '../../../assets/icon-subscript.svg';
import { useData } from '../../../hooks/useData';
var ColorDrawer = function (_a) {
    var className = _a.className, onSelectConfirm = _a.onSelectConfirm;
    var _b = useData(), peopleNumber = _b.peopleNumber, colors = _b.colors, images = _b.images, selectedColor = _b.selectedColor, setSelectedColor = _b.setSelectedColor;
    var _c = useState([]), localColor = _c[0], setLocalColor = _c[1];
    useEffect(function () {
        setLocalColor(__spreadArray([], selectedColor, true));
    }, [selectedColor]);
    var sortedColors = useMemo(function () {
        if (peopleNumber === 1)
            return [colors];
        var arr = [];
        colors.forEach(function (item) {
            if (item.belongPeople !== undefined) {
                if (arr[item.belongPeople]) {
                    arr[item.belongPeople].push(item);
                }
                else
                    arr[item.belongPeople] = [item];
            }
        });
        if (arr.length !== peopleNumber) {
            console.error('颜色数量跟人数对不上，请检查您的数据');
        }
        return arr;
    }, [peopleNumber, colors]);
    var changeSkinColor = function (belongPeople, color) {
        localColor[belongPeople] = color;
        setLocalColor(__spreadArray([], localColor, true));
    };
    var onConfirm = function () {
        var isSameColor = selectedColor.every(function (item, index) { return item.name === localColor[index].name; });
        onSelectConfirm(isSameColor);
        if (!isSameColor)
            setSelectedColor(__spreadArray([], localColor, true));
    };
    return (_jsx(Wrapper, { position: "absolute", className: "_sz-z-[4] ".concat(className), children: _jsx(Drawer, { position: "top", mask: true, children: _jsxs("div", { className: "_sz-bg-white _sz-p-5", children: [_jsx("h1", { className: "_sz-m-0 _sz-mb-6 _sz-mt-4 _sz-p-0 _sz-text-center _sz-text-base _sz-font-extrabold _sz-text-black", children: I18n.format('modules.mini.me.choose.skin.color.title') }), new Array(peopleNumber).fill(undefined).map(function (_, belongPeople) {
                        var _a;
                        return (_jsxs("div", { className: "_sz-mt-4 _sz-flex", children: [!images[belongPeople][0].isDefault ? (_jsx("div", { className: "_sz-h-14 _sz-w-14 _sz-rounded-full _sz-bg-[#F1F1F1]", children: _jsx("img", { src: images[belongPeople][0].image, alt: "avatar", className: "_sz-h-full _sz-w-full _sz-object-contain _sz-p-1" }) })) : (_jsx(AvatarPlaceholder, { className: "!_sz-h-14 !_sz-w-14" })), _jsx("div", { className: "_sz-grid _sz-flex-1 _sz-grid-cols-3 _sz-gap-3 _sz-p-2.5\t", children: (_a = sortedColors[belongPeople]) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                        var _a;
                                        var isSelected = ((_a = localColor[belongPeople]) === null || _a === void 0 ? void 0 : _a.name) === item.name;
                                        return (_jsx("div", { className: "_sz-relative _sz-h-9 _sz-w-full _sz-cursor-pointer _sz-rounded", style: {
                                                backgroundColor: item.color,
                                                border: isSelected
                                                    ? '2px solid var(--sunzi-theme-color)'
                                                    : undefined
                                            }, onClick: function () { return changeSkinColor(belongPeople, item); }, children: isSelected && (_jsx(Icon, { className: "_sz-absolute -_sz-right-1.5 -_sz-top-1.5", color: "var(--sunzi-theme-color)", size: 20, children: _jsx(SubscriptIcon, {}) })) }, item.name));
                                    }) })] }, belongPeople));
                    }), _jsx("button", { type: "button", onClick: onConfirm, className: "_sz-mt-7 _sz-h-13 _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white", children: (I18n.format('modules.global.done') || '').toUpperCase() })] }) }) }));
};
export default ColorDrawer;
